// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_6U3td","empty":"empty_1TJ7F"};